import { render, staticRenderFns } from "./Notifications_mobile.vue?vue&type=template&id=5a7e4a41&scoped=true&"
import script from "./Notifications_mobile.vue?vue&type=script&lang=js&"
export * from "./Notifications_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_mobile.vue?vue&type=style&index=0&id=5a7e4a41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7e4a41",
  null
  
)

export default component.exports